import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { Constants } from 'src/app/shared/constants';


/**
 * Sort selector component
 * provides radio controls to set sorting preference
 * @input string
 * @class SortSelectorComponent
 * @typedef {SortSelectorComponent}
 */
@Component( {
    selector: 'riege-sort-selector',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatRadioModule],
    templateUrl: './sort-selector.component.html',
    styleUrl: './sort-selector.component.css',
    standalone: true
} )
export class SortSelectorComponent {
    @Input() selectedSorting? = '';

    @Output() directionSelected = new EventEmitter();

    sorting = signal( '' );

    readonly sortDefs = Constants.sortbyname;

    /** set sorting when given */
    ngOnInit() {
        if ( this.selectedSorting ) {
            this.sorting.set( this.selectedSorting );
        }
    }

    /** pass selected services to service */
    selectionChanged() {
        this.directionSelected.emit( this.sorting() );
    }
}
